<template>
  <div>
    <el-row
      class="repeater-row mb-20"
      v-for="(field, index) in fields"
      :key="index"
    >
      <el-col
        :span="9"
      >
        <el-input-number
          :disabled="!isAdmin"
          :controls="false"
          v-model="field.qrCodeStart"
          :min="1"
          :precision="0"
        />
      </el-col>
      <el-col
        :span="9"
        :offset="2"
      >
        <el-input-number
          :disabled="!isAdmin"
          :controls="false"
          v-model="field.qrRangeSize"
          :min="1"
          :precision="0"
        />
      </el-col>
      <el-col
        v-if="isAdmin"
        :span="3"
        :offset="1"
      >
        <i
          class="el-icon-circle-plus repeater-row-add"
          @click="addRepeaterField(index)"
        />
        <i
          class="el-icon-remove repeater-row-remove"
          @click="removeRepeaterField(index)"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'QrCodeRangesRepeater',
  props: {
    fields: {
      type: Array,
      default: () => {
        return new Array([{ qrCodeStart: undefined, qrRangeSize: undefined }]);
      }
    },
    prop: {
      type: String,
      default: ''
    },
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    addRepeaterField (index) {
      this.fields.splice(index + 1, 0, ...[{ qrCodeStart: undefined, qrRangeSize: undefined }]);
    },
    removeRepeaterField (index) {
      if (this.fields.length > 1) {
        this.fields.splice(index, 1);
      } else {
        this.$message.warning('You can\t delete all items');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.repeater-row {
  &-add, &-remove {
    font-size: 25px;
    cursor: pointer;
    margin-right: 5px;
  }
}
</style>
